import * as fromDatatype from "../datatype-library";

export interface bl_fi_my_einvoice_notification_queue_RowInterface{
    guid: fromDatatype.GuidDataFieldInterface;
    to_irb_hdr_guid: fromDatatype.GuidDataFieldInterface;
    channel_type: fromDatatype.VarcharDatatypeInterface;
    txn_type: fromDatatype.VarcharDatatypeInterface;
    descr: fromDatatype.VarcharDatatypeInterface;
    priority: fromDatatype.NumericDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_my_einvoice_notification_queue_RowClass implements bl_fi_my_einvoice_notification_queue_RowInterface{
    guid: fromDatatype.GuidDataFieldInterface;
    to_irb_hdr_guid: fromDatatype.GuidDataFieldInterface;
    channel_type: fromDatatype.VarcharDatatypeInterface;
    txn_type: fromDatatype.VarcharDatatypeInterface;
    descr: fromDatatype.VarcharDatatypeInterface;
    priority: fromDatatype.NumericDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}
